import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUserPreferencesRetrievalRequestFailure() {
      return getState().request.isFailure;
    },
    isUserPreferencesRetrievalRequestPending() {
      return getState().request.isPending;
    },
    isUserPreferencesRetrievalRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getUserPreferences() {
      return getState().preferences;
    },
  };
}

export { createSelector };
